




import Vue from 'vue';
import Board from '../components/Board.vue';

export default Vue.extend({
  name: 'Home',

  components: {
    Board,
  },
});
